// Brand-aligned categorical palette for Recharts.
export const CHART_COLORS = [
  '#E4002B', // brand red
  '#F0803C', // warm orange
  '#1F9D55', // green
  '#2563EB', // blue
  '#8B5CF6', // violet
  '#EAB308', // amber
  '#0EA5E9', // sky
  '#DB2777', // pink
];

export const PAYMENT_COLORS: Record<string, string> = {
  CASH: '#1F9D55',
  UPI: '#2563EB',
  CARD: '#F0803C',
  BANK: '#8B5CF6',
  OTHER: '#8A827B',
};

export function colorFor(index: number): string {
  return CHART_COLORS[index % CHART_COLORS.length];
}
